import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';

interface UseRequireAuthOptions {
  redirectPath?: string;
  onRedirect?: () => void;
}

export const useRequireAuth = (options: UseRequireAuthOptions = {}) => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { redirectPath = '/', onRedirect } = options;

  useEffect(() => {
    if (!isLoading && !user) {
      navigate(redirectPath, { 
        state: { from: location },
        replace: true 
      });
      onRedirect?.();
    }
  }, [user, isLoading, navigate, location, redirectPath, onRedirect]);

  return { user, isLoading };
}; 